import Vue from 'vue'
import Router from 'vue-router'
//import Home from 
import ItemInfo from '../views/ItemInfo.vue'

Vue.use(Router);

let routeslist = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/HomeView.vue'),
    meta: { requireAuth: false, breadcrumb: [{ name: "home" }] }
  },
  {
    path: '/r/:referido',
    name: 'Home Referido',
    component: () => import(/* webpackChunkName: "home" */ '@/views/HomeView.vue'),
    meta: { requireAuth: false, breadcrumb: [{ name: "home" }] }
  },
  { path: '/about', name: 'About', component: '../views/AboutRagnamex.vue', meta: { requireAuth: false, breadcrumb: [{ name: "about" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/AboutRagnamex.vue'), meta: { breadcrumb: [] } },
  { path: '/features', name: 'Features', component: '../views/Features.vue', meta: { requireAuth: false, breadcrumb: [{ name: "feature" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/Features.vue'), meta: { breadcrumb: [] } },
  { path: '/information', name: 'Infomation', component: '../views/Information.vue', meta: { requireAuth: false, breadcrumb: [{ name: "serverinfo" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/Information.vue'), meta: { breadcrumb: [] } },
  { path: '/ranking', name: 'Ranking', component: '../views/RankingView.vue', meta: { requireAuth: false, breadcrumb: [{ name: "ranking" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/RankingView.vue'), meta: { breadcrumb: [] } },
  { path: '/guilds', name: 'Guilds', component: '../views/GuildView.vue', meta: { requireAuth: false, breadcrumb: [{ name: "guilds" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/GuildView.vue'), meta: { breadcrumb: [] } },
  { path: '/deathlog', name: 'DeathLog', component: '../views/DeathlogView.vue', meta: { requireAuth: false, breadcrumb: [{ name: "deathlog" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/DeathlogView.vue'), meta: { breadcrumb: [] } },
  { path: '/tokenragnamex', name: 'Ragnamex Token', component: '../views/RagnamexToken.vue', meta: { requireAuth: false, breadcrumb: [{ name: "serverinfo" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/RagnamexToken.vue'), meta: { breadcrumb: [] } },
  { path: '/shop', name: 'Shop', component: '../views/Shop.vue', meta: { requireAuth: false, breadcrumb: [{ name: "shop" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/Shop.vue'), meta: { breadcrumb: [] } },
  { path: '/vip', name: 'VIP', component: '../views/VipView.vue', meta: { requireAuth: false, breadcrumb: [{ name: "serverinfo" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/VipView.vue'), meta: { breadcrumb: [] } },
  { path: '/services', name: 'Services', component: '../views/Services.vue', meta: { requireAuth: false, breadcrumb: [{ name: "services" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/Services.vue'), meta: { breadcrumb: [] } },
  { path: '/downloads', name: 'Downloads', component: '../views/DownloadView.vue', meta: { requireAuth: false, breadcrumb: [{ name: "downloads" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/DownloadView.vue'), meta: { breadcrumb: [] } },
  { path: '/guides', name: 'Guides', component: '../views/Guides.vue', meta: { requireAuth: false, breadcrumb: [{ name: "guides" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/Guides.vue'), meta: { breadcrumb: [] } },
  { path: '/market', name: 'Market', component: '../views/MarketVue.vue', meta: { requireAuth: false, breadcrumb: [{ name: "market" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/MarketVue.vue'), meta: { breadcrumb: [] } },
  
  // { path: '/db', name: 'Data Base - Ragnamex', component: '../views/db/profession.vue', meta: { requireAuth: false, breadcrumb: [{ name: "Professions" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/db/profession.vue'), meta: { breadcrumb: [] } },
  // { path: '/db/proffesions', name: 'Home Referido', component: '../views/db/profession.vue', meta: { requireAuth: false, breadcrumb: [{ name: "Professions" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/db/profession.vue'), meta: { breadcrumb: [] } },
  // { path: '/db/item', name: 'Home Referido', component: '../views/HomeView.vue', meta: { requireAuth: false, breadcrumb: [{ name: "home" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/HomeView.vue'), meta: { breadcrumb: [] } },
  // { path: '/db/item/:id', name: 'Home Referido', component: '../views/HomeView.vue', meta: { requireAuth: false, breadcrumb: [{ name: "home" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/HomeView.vue'), meta: { breadcrumb: [] } },
  { path: '/donate', name: 'Donations', component: '../views/HowDonate.vue', meta: { requireAuth: false, breadcrumb: [{ name: "donate" }] }, component: () => import(/* webpackChunkname: "login" */ '@/views/HowDonate.vue'), meta: { breadcrumb: [] }
  },
  {
    path: '/donate/success',
    name: 'Donaciones Success',
    component: '../views/donate/donate_success.vue',
    meta: {
      requireAuth: false,
      breadcrumb: [{ name: "donate" }]
    },
    component: () =>
      import(/* webpackChunkname: "login" */ '@/views/donate/donate_success.vue'),
      meta: {
        breadcrumb: []
      }
  },
  {
    path: '/donate/cancel',
    name: 'Donaciones Cancel',
    component: '../views/donate/donate_cancel.vue',
    meta: {
      requireAuth: false,
      breadcrumb: [{ name: "donate" }]
    },
    component: () =>
      import(/* webpackChunkname: "login" */ '@/views/donate/donate_cancel.vue'),
      meta: {
        breadcrumb: []
      }
  },
  {
    path: '/auction',
    name: 'Auction House',
    component: '../views/AuctionHouse.vue',
    meta: {
      requireAuth: false,
      breadcrumb: [{ name: "auctionhouse" }]
    },
    component: () =>
      import(/* webpackChunkname: "login" */ '@/views/AuctionHouse.vue'),
      meta: {
        breadcrumb: []
      }
  },
  {
    path: '/item/:id',
    name: 'Item',
    component: ItemInfo,
    meta: {
      requireAuth: false,
      breadcrumb: [{ name: "item" }]
    },
    component: () =>
      import(/* webpackChunkname: "login" */ '@/views/ItemInfo.vue'),
      meta: {
        breadcrumb: []
      }
  },
  {
    path: '/myaccount',
    name: 'My Account',
    component: () => import('@/views/managers/MyAccount.vue'),
    meta: {
      requireAccountId: true,
      model: 'Login',
      breadcrumb: []
    }
  },
  {
    path: '/mycharacters',
    name: 'My Characters',
    component: () => import('@/views/managers/MyCharacters.vue'),
    meta: {
      requireAccountId: true,
      model: 'Char',
      breadcrumb: []
    }
  },
  {
    path: '/acp',
    name: 'ACP',
    component: () => import('@/views/ACP.vue'),
    meta: {
      requireAccountId: true,
      requiredAccountId: 99,
      model: 'Login',
      breadcrumb: []
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  }
];

const getStoredUserData = () => {
  const raw = localStorage.getItem('userData');
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch (error) {
    localStorage.removeItem('userData');
    return null;
  }
};

const router = new Router({
  mode: 'history',
  routes: routeslist
});

router.beforeEach((to, from, next) => {
  if (to.meta && to.meta.requireAccountId) {
    const userData = getStoredUserData();
    const accountId = Number(userData && userData.account_id ? userData.account_id : 0);

    if (!accountId) {
      next('/');
      return;
    }

    if (to.meta.requiredAccountId && accountId !== Number(to.meta.requiredAccountId)) {
      next('/');
      return;
    }
  }

  document.title = `${ process.env.VUE_APP_TITLE} :: ${ to.name }`
  next();
});

export default router;
